export const whatsNewQuery = groq`
  *[ _type == 'whatIsNew' ] | order(_createdAt desc) [0...4] {
    currentPathname,
    title,
    description,
    heroImage,
    _type,
    slug,
    person {
      reference->,
    },
    _id,
    "articleDate": coalesce(articleDate, startDateTime.utc),
    taxonomies[]-> {
      _id,
      prefLabel
    }
  }
`;
